import { PropsWithChildren, ReactNode } from "react";
import { makeStyles, createStyles, Theme, SvgIcon, IconButton, Box } from "@material-ui/core";
import { Launch } from "@material-ui/icons";
import clsx from "clsx";

import { Hide } from "~components/Icons";

export type LayoutProps = PropsWithChildren<{
  title: string | ReactNode;
  sticky?: boolean;
  onViewMore?: () => void;
  onHide?: () => void;
}>;

export const Layout = ({ title, children, onViewMore, onHide, sticky = false }: LayoutProps) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <div
        className={clsx({
          [classes.header]: true,
          [classes.headerSticky]: sticky,
        })}
      >
        <h3 className={classes.headerText}>{title}</h3>
        <Box display="flex" alignItems="center">
          {onViewMore ? (
            <div className={classes.action} onClick={onViewMore} role="button">
              <IconButton color="primary" size="small" classes={{ root: classes.iconRoot }}>
                <Launch className={classes.launch} />
              </IconButton>
              View More
            </div>
          ) : null}
          {onHide ? (
            <div className={classes.action} onClick={onHide} role="button">
              <SvgIcon
                component={Hide}
                color="primary"
                className={classes.hide}
                viewBox="0 0 24 24"
              />
              Hide
            </div>
          ) : null}
        </Box>
      </div>
      {children}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(2),
      boxShadow: "0 0 1px 0 rgba(10, 31, 68, 0.1)",
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2.5),
      fontFamily: theme.typography.fontFamily,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
    headerSticky: {
      position: "sticky",
      backgroundColor: "white",
      top: 0,
      zIndex: 1301 /** @note one bigger vs paper to ensure sticky header is on top of the content */,
    },
    headerText: { margin: 0, fontSize: 22, lineHeight: "32px" },
    action: {
      fontFamily: "Lota Grotesque",
      fontSize: 12,
      fontWeight: "bold",
      lineHeight: 1.58,
      color: "#20252b",
      textTransform: "uppercase",
      display: "flex",
      cursor: "pointer",
    },
    iconRoot: {
      padding: 0,
      marginRight: 8,
    },
    launch: {
      fontSize: 16,
      marginTop: -2,
    },
    hide: {
      fontSize: 16,
      marginRight: 8,
      marginLeft: 16,
      padding: 2,
    },
  }),
);
